import { apiClient } from '@/lib/apiClient';
import type { Page } from '@/types/api';

import type {
  Establecimiento,
  EstablecimientoCambiarProfesional,
  EstablecimientoCreate,
  EstablecimientoListParams,
  EstablecimientoUpdate,
  EstablecimientosByProfesionalParams,
} from './types';

const BASE = '/establecimientos';

export const establecimientosApi = {
  async create(data: EstablecimientoCreate, signal?: AbortSignal): Promise<Establecimiento> {
    const response = await apiClient.post<Establecimiento>(BASE, data, { signal });
    return response.data;
  },

  async list(
    params: EstablecimientoListParams & { signal?: AbortSignal } = {}
  ): Promise<Page<Establecimiento>> {
    const { signal, ...queryParams } = params;
    const response = await apiClient.get<Page<Establecimiento>>(BASE, {
      params: queryParams,
      signal,
    });
    return response.data;
  },

  async listByProfesional(
    uidProfesional: string,
    params: EstablecimientosByProfesionalParams & { signal?: AbortSignal } = {}
  ): Promise<Page<Establecimiento>> {
    const { signal, ...queryParams } = params;
    const response = await apiClient.get<Page<Establecimiento>>(
      `${BASE}/by-profesional/${uidProfesional}`,
      { params: queryParams, signal }
    );
    return response.data;
  },

  async getById(uid: string, signal?: AbortSignal): Promise<Establecimiento> {
    const response = await apiClient.get<Establecimiento>(`${BASE}/${uid}`, { signal });
    return response.data;
  },

  async update(
    uid: string,
    data: EstablecimientoUpdate,
    signal?: AbortSignal
  ): Promise<Establecimiento> {
    const response = await apiClient.patch<Establecimiento>(`${BASE}/${uid}`, data, { signal });
    return response.data;
  },

  async cambiarProfesional(
    uid: string,
    data: EstablecimientoCambiarProfesional,
    signal?: AbortSignal
  ): Promise<Establecimiento> {
    const response = await apiClient.post<Establecimiento>(
      `${BASE}/${uid}/cambiar-profesional`,
      data,
      { signal }
    );
    return response.data;
  },

  async remove(uid: string, signal?: AbortSignal): Promise<void> {
    await apiClient.delete(`${BASE}/${uid}`, { signal });
  },
};
